export const REFERRAL_PARTNERS = {};

export const getReferralPartner = (code) => {
  if (!code) {
    return null;
  }

  return REFERRAL_PARTNERS[code.toUpperCase()] ?? null;
};
